export interface AchievementCategory {
  id: number;
  displayOrder: number;
  name: string;
}

export enum AchievementType {
  ALMOST_FINISHED = 'almost_finished',
  LATEST_ACHIEVED = 'latest_achieved',
}
